<main id="main" class="main">
  <div class="mainScreen">
    <!-- <div class="row mx-0" style="box-shadow: 0 5px 5px rgba(0,0,0,0.2);" *ngIf="role != 'ADMINISTRATOR' && dashboardUrls?.length <= 0">
      <h6 class="admintitle">{{lang.Dashboard}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i></h6>
    </div>
    <div class="row mx-0" style="box-shadow: 0 5px 5px rgba(0,0,0,0.2);" *ngIf="role == 'ADMINISTRATOR' || dashboardUrls?.length > 0">
      <h6 class="admintitle text-center" *ngFor="let dashboard of dashboardUrls">{{dashboard?.name}}</h6>
    </div>
    <br>

    <div class="row" *ngIf="role != 'ADMINISTRATOR' && dashboardUrls?.length <= 0">
      <div class="col-12">
        <div class="card widget-flat">
          <h6 class="admintitle">{{lang.Primary_Information}}&nbsp;&nbsp;</h6>

          <div class="card-body">
            <div class="row">
              <div class="form-group  col-4">
                <div><b>{{lang.User_Name}}</b></div>
                <div class="text-capitalize">{{userName}}</div>
              </div>
              <div class="form-group  col-4">
                <div><b>{{lang.Role}}</b></div>
                <div class="text-capitalize">{{role}}</div>
              </div>
              <div class="form-group  col-4">
                <div><b>{{lang.Email}}</b></div>
                <div>{{email}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div *ngIf="dashboardUrls?.length > 0; else noUrls">
    <!-- Dashboard titles as clickable buttons -->
      <div class="d-flex flex-nowrap justify-content-center mb-3">
        <button
          class="mx-2 mb-2 w-100 border-0 bg-transparent p-0"
          *ngFor="let dashboard of dashboardUrls; let i = index"
          [class.active]="selectedDashboardIndex === i"
          (click)="selectedDashboardIndex = i"
        >
          <h6 class="admintitle text-start" *ngIf="dashboardUrls.length==1 && role!='ADMINISTRATOR'">{{ lang.Dashboard }}</h6>
          <h6 class="admintitle" *ngIf="dashboardUrls.length>1 || role=='ADMINISTRATOR'">{{ dashboard.name }}</h6>
        </button>
      </div>

      <h5 class="month-year" *ngIf="role == 'ADMINISTRATOR' || dashboardUrls?.length > 0">
        <!-- <i class="fa bi-chevron-left"></i>
        <i class="fa bi-chevron-left"></i> -->
        <ng-container *ngIf="dashboardUrls[selectedDashboardIndex]?.url != ''">
          {{currentMonth}}
        </ng-container>
        <!-- <i class="fa bi-chevron-right"></i>
        <i class="fa bi-chevron-right"></i> -->
      </h5>

  
    <button 
      class="btn btn-primary" 
      type="button" 
      style="position: absolute; top: 85%; background: #142A49 !important; font-size: 10px;"
      data-bs-toggle="modal" 
      data-bs-target="#arrearsreport"  
      (click)="getReportsForArrears()"
    >
      Arrears Report
    </button>
    <!-- Show the selected iframe -->
      <div style="height: 80vh;">
        <ng-container *ngIf="dashboardUrls[selectedDashboardIndex]?.url; else showPrimaryInfo">
          <iframe
            [title]="dashboardUrls[selectedDashboardIndex]?.name || 'Dashboard'"
            width="100%"
            height="100%"
            style="margin-bottom: 40px;"
            [src]="dashboardUrls[selectedDashboardIndex]?.url"
            frameborder="0"
            allowfullscreen="true"
          ></iframe>
        </ng-container>
      </div>
    </div>

    <ng-template #noUrls>
      <div class="d-flex flex-nowrap justify-content-center mb-3">
        <button class="mx-0 mb-2 w-100 border-0 bg-transparent p-0">
          <h6 class="admintitle text-start">{{ lang.Dashboard }}</h6>
        </button>
      </div>
    </ng-template>

    <!-- <div *ngFor="let dashboard of dashboardUrls" style="height: 80vh;">
      <iframe
        *ngIf="dashboard?.url != '' && dashboard?.url != undefined && dashboard?.url != null; else showPrimary"
        title="group_benefitz_dashboard"
        width="100%"
        height="100%"
        style="margin-bottom: 40px;"
        [src]="dashboard?.url"
        frameborder="0"
        allowfullscreen="true"
      ></iframe>
    </div> -->

    <!-- Fallback for missing dashboardUrls entirely -->
    <ng-container *ngIf="dashboardUrls?.length == 0">
      <ng-container *ngTemplateOutlet="showPrimaryInfo"></ng-container>
    </ng-container>

    <!-- Reusable primary info fallback block -->
    <ng-template #showPrimaryInfo>
      <div class="row" *ngIf="portalInfo">
        <div class="col-12">
          <div class="card widget-flat">
            <h6 class="admintitle">Portal Information &nbsp;&nbsp;</h6>
            <div class="card-body">
              <div class="row">
                <div class="form-group col-4">
                  <div><b>Name</b></div>
                  <div class="text-capitalize">{{ portalInfo.name }}</div>
                </div>
                <div class="form-group col-4">
                  <div><b>{{ lang.Role }}</b></div>
                  <div class="text-capitalize">{{ portalInfo.role }}</div>
                </div>
                <div class="form-group col-4">
                  <div><b>{{ lang.Email }}</b></div>
                  <div>{{ portalInfo.email }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


       <div class="row" *ngIf="userInfo">
        <div class="col-12">
          <div class="card widget-flat">
            <h6 class="admintitle">User Information&nbsp;&nbsp;</h6>
            <div class="card-body">
              <div class="row">
                <div class="form-group col-4">
                  <div><b>{{ lang.User_Name }}</b></div>
                  <div class="text-capitalize">{{ userInfo.name }}</div>
                </div>
                <div class="form-group col-4">
                  <div><b>{{ lang.Role }}</b></div>
                  <div class="text-capitalize">{{ userInfo.role }}</div>
                </div>
                <div class="form-group col-4">
                  <div><b>{{ lang.Email }}</b></div>
                  <div>{{ userInfo.email }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- <div class="row">

  <div class="col-12">

    <div class="card widget-flat">
      <h6 class="admintitle"><a class="bartitlelabel">Customers&nbsp;&nbsp;</a></h6>

      <div class="card-body">
        <div class="row">
          <div class="form-group  col-2">
            <div class="card widget-flat">
              <div class="card-body">

                  <span class="text-muted fw-normal mt-0" title="Number of Customers" style="font-size: 20px;">2128</span>

                  <p class="mb-0 text-muted">
                      <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>Total</span>

                    </p>
              </div>

          </div>
          </div>
          <div class="form-group  col-10">
              <div class="row">
                <div class="col-2">
                  <div class="card widget-flat">
                    <div class="card-body">

                        <span class="text-muted fw-normal mt-0" title="Number of Customers">2128</span>

                        <p class="mb-0 text-muted">
                            <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>Total</span>

                          </p>
                    </div>
                </div>
                </div>
                <div class="col-2">
                  <div class="card widget-flat">
                    <div class="card-body">

                        <span class="text-muted fw-normal mt-0" title="Number of Customers">{{finalResults.customer.suspendedCoustomers.label}}</span>

                        <p class="mb-0 text-muted">
                            <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>{{finalResults.customer.suspendedCoustomers.display}}</span>

                          </p>
                    </div>

                </div>
                </div>
                <div class="col-2">
                  <div class="card widget-flat">
                    <div class="card-body">

                        <span class="text-muted fw-normal mt-0" title="Number of Customers">{{finalResults.customer.suspendedCoustomers.label}}</span>

                        <p class="mb-0 text-muted">
                            <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>{{finalResults.customer.suspendedCoustomers.display}}</span>

                          </p>
                    </div>

                </div>
                </div>
                <div class="col-2">
                  <div class="card widget-flat">
                    <div class="card-body">

                        <span class="text-muted fw-normal mt-0" title="Number of Customers">{{finalResults.customer.suspendedCoustomers.label}}</span>

                        <p class="mb-0 text-muted">
                            <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>{{finalResults.customer.suspendedCoustomers.display}}</span>

                          </p>
                    </div>

                </div>
                </div>
                <div class="col-2">
                  <div class="card widget-flat">
                    <div class="card-body">

                        <span class="text-muted fw-normal mt-0" title="Number of Customers">{{finalResults.customer.suspendedCoustomers.label}}</span>

                        <p class="mb-0 text-muted">
                            <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>{{finalResults.customer.suspendedCoustomers.display}}</span>

                          </p>
                    </div>


                </div>
                </div>
                <div class="col-2">
                  <div class="card widget-flat">
                    <div class="card-body">

                        <span class="text-muted fw-normal mt-0" title="Number of Customers">{{finalResults.customer.suspendedCoustomers.label}}</span>

                        <p class="mb-0 text-muted">
                            <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>{{finalResults.customer.suspendedCoustomers.display}}</span>

                          </p>
                    </div>

                </div>
                </div>
                </div>
                <br>
                <div class="row">

                  <div class="col-2">
                    <div class="card widget-flat">
                      <div class="card-body">

                          <span class="text-muted fw-normal mt-0" title="Number of Customers">{{finalResults.customer.suspendedCoustomers.label}}</span>

                          <p class="mb-0 text-muted">
                              <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>{{finalResults.customer.suspendedCoustomers.display}}</span>

                            </p>
                      </div>

                  </div>
                  </div>
                  <div class="col-2">
                    <div class="card widget-flat">
                      <div class="card-body">

                          <span class="text-muted fw-normal mt-0" title="Number of Customers">{{finalResults.customer.suspendedCoustomers.label}}</span>

                          <p class="mb-0 text-muted">
                              <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>{{finalResults.customer.suspendedCoustomers.display}}</span>

                            </p>
                      </div>

                  </div>
                  </div>

                  </div>
          </div>


        </div>
      </div>
  </div>
  </div>

 </div> -->



    <!-- <div class="row">
  <br>
  <div class="col-3">

      <div class="card widget-flat">
          <div class="card-body">
              <div class="float-end">
                <i class="fa fa-users" aria-hidden="true" style="font-size: 25px;"></i>
              </div>
              <span class="text-muted fw-normal mt-0" title="Number of Customers">{{finalResults.customer.suspendedCoustomers.label}}</span>

              <p class="mb-0 text-muted">
                  <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>{{finalResults.customer.suspendedCoustomers.display}}</span>

              </p>
          </div>
      </div>


  </div>
  <div class="col-3">

    <div class="card widget-flat">
      <div class="card-body">
          <div class="float-end">
            <i class="fa fa-users" aria-hidden="true" style="font-size: 25px;"></i>
          </div>
          <span class="text-muted fw-normal mt-0" title="Number of Customers">{{finalResults.customer.cancelledCoustomers.label}}</span>

          <p class="mb-0 text-muted">
              <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>{{finalResults.customer.cancelledCoustomers.display}}</span>

            </p>
      </div>
  </div>
  </div>
  <div class="col-3">

    <div class="card widget-flat">
      <div class="card-body">
          <div class="float-end">
            <i class="fa fa-users" aria-hidden="true" style="font-size: 25px;"></i>
          </div>
          <span class="text-muted fw-normal mt-0" title="Number of Customers">{{finalResults.customer.otherCoustomers.label}}</span>

          <p class="mb-0 text-muted">
              <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>{{finalResults.customer.otherCoustomers.display}}</span>

            </p>
      </div>

  </div>
  </div>
  <div class="col-3">
    <div class="card widget-flat">
      <div class="card-body">
          <div class="float-end">
            <i class="fa fa-users" aria-hidden="true" style="font-size: 25px;"></i>
          </div>
          <span class="text-muted fw-normal mt-0" title="Number of Customers">{{finalResults.customer.corporateEmployee.label}}</span>

          <p class="mb-0 text-muted">
              <span class="text-success me-2"><i class="mdi mdi-arrow-up-bold"></i>{{finalResults.customer.corporateEmployee.display}}</span>

            </p>
      </div>

  </div>
  </div>
 </div> -->

    <div id="arrearsreport" class="modal my-custom-modal fade modalposition " data-bs-backdrop="static" tabindex="-1"
      aria-hidden="true" style="max-width: 100% !important;"
      >
          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
              <div class="modal-content" id="dependent-content">
                  <div class="modal-header" id="backgroundColor">
              <span class="modal-title">
                Arrears report
              </span>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body linescrollbar" style="overflow-y: auto;">
      
              <img
                  src="../../../assets/img/download_list.png"
                  class="download-list"
                  *ngIf="arrearsData?.length > 0"
                  (click)="downloadArrears()"
                />
      
      
      
                <div class="row m-4">
                <div class="table-responsive">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="DataTables_Table_1"
                    class="table text-nowrap">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Customer ID</th>
                  <th>Type</th>
                  <th>Customer name</th>
                  <th>Company name</th>
                  <th>Invoice No</th>
                  <th>Payment method</th>
                  <th>Due Date</th>
                  <th style="text-align: center;">Amount</th>
                  <th>Status</th>
                  <th>Reason if avail</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of arrearsData; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{item?.customerId}}</td>
                  <td>{{item?.customerObj?.isCorporateAccount ? "CORP" : "GIG"}}</td>
                  <td>{{item?.customerObj?.firstName + ' ' + item?.customerObj?.lastName}}</td>
                  <td>{{item?.customerObj?.broker?.name}}</td>
                  <td>{{item?.invoiceNumber}}</td>
                  <td>{{item?.customerObj?.paymentMethod.split('_').join(' ').toUpperCase()}}</td>
                  <td>{{formatDate(item?.dueDate)}}</td>
                  <td style="text-align: right; padding-right: 22px;">${{item?.invoiceAmount2}}</td>
                  <td>{{item?.status?.toUpperCase()}}</td>
                  <td>NA</td>
                </tr>
              </tbody>
            </table>
            <div style="margin-left: 422px; margin-top: -28px;">Total Amount: {{totalArrearsAmount}}</div>
 
              
                </div>
                </div>
      
                  
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                tooltip="List will be replaced overwriting existing."
                id="closeaddadmin"
                data-bs-dismiss="modal"
                #closemodel
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

  </div>
</main>